export const eventHistoryKeys = {
  events: (type?: string, filters?: unknown, sort?: unknown) =>
    type === undefined && filters === undefined && sort === undefined
      ? (['events'] as const)
      : (['events', type, filters, sort] as const),
  eventsInProgress: () => ['events', 'inProgress'] as const,
  homeEvents: (type?: string) =>
    type === undefined ? (['home-events'] as const) : (['home-events', type] as const),
  eventsCounts: () => ['events-counts'] as const,
  event: (id?: string) => {
    if (id === undefined) {
      return ['event'] as const;
    }

    return ['event', id] as const;
  },
  eventStatistics: (bloggerEventId: string) => ['event-statistics', bloggerEventId] as const,
  availableNetworks: () => ['available-networks'] as const,
};
